import type * as React from 'react';

import {
    Button,
    DialogBody,
    DialogCloseButton,
    DialogFooter,
    useDialogClose,
} from '@gitbook/spine-react';

import { useSiteInviteForm } from '../../../../Components';
import { useSiteContext } from '../../../../state';

/**
 * Invite users/teams directly to a site.
 *
 * Renders the dialog body (invite input) and footer (Invite action) as siblings so the
 * primary action sits in the dialog footer, like the organization invite dialog.
 * The browsable list of who already has access (and the site default permission)
 * lives on the dedicated Site Members screen.
 */
export function SitePermissionsList(): React.ReactElement {
    const { organizationId, site } = useSiteContext();
    const closeDialog = useDialogClose();
    const form = useSiteInviteForm({ organizationId, site, onInvited: closeDialog });

    return (
        <>
            <DialogBody>{form.fields}</DialogBody>
            <DialogFooter>
                <DialogCloseButton label="Cancel" />
                <Button
                    kind="primary"
                    size="medium"
                    disabled={!form.canInvite}
                    onPress={form.invite}
                    label="Invite"
                />
            </DialogFooter>
        </>
    );
}
